export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

export const CHECK_AUTH = "CHECK_AUTH";
export const GET_ROLES = "GET_ROLES";

export const CREATE_JOB = "CREATE_JOB";
export const GET_JOB = "GET_JOB";
export const GET_ALL_JOB = "GET_ALL_JOB";
export const GET_HOTSPOT_INFO = "GET_HOTSPOT_INFO";
export const GET_LOCATION_LOOKUP = "GET_LOCATION_LOOKUP";
export const GET_HOTSPOT_DETAIL = "GET_HOTSPOT_DETAIL";

export const GET_RESULT = "VIEW_RESULT";
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB';
export const UPDATE_JOB_STATUS = 'UPDATE_JOB_STATUS';
export const UPDATE_JOB_PROGRESS = 'UPDATE_JOB_PROGRESS';

export const ADD_WMS_LAYER = 'ADD_WMS_LAYER';
export const SET_COLLECTION = 'SET_COLLECTION';

